import formatCurrency from 'format-currency';

class InvoiceAddLineItemModalController {

  constructor($scope, $uibModalInstance, InvoiceService, toastr) {
    'ngInject';

    $scope.invoice = $uibModalInstance.invoice;
    $scope.availableLineItems = $uibModalInstance.availableLineItems || [];
    $scope.saving = false;
    $scope.allSelected = false;

    $scope.currency = (value) => formatCurrency(value);

    $scope.getLaborCategoryName = (lineItem) => {
      if (lineItem.laborCategory && lineItem.laborCategory.name) {
        return lineItem.laborCategory.name;
      }

      if (lineItem.chargeCode && lineItem.chargeCode.popRate && lineItem.chargeCode.popRate.laborCategory) {
        return lineItem.chargeCode.popRate.laborCategory.name;
      }

      return '';
    };

    $scope.getRate = (lineItem) => {
      if (lineItem.rate != null) {
        return lineItem.rate;
      }

      if (lineItem.chargeCode && lineItem.chargeCode.popRate) {
        return lineItem.chargeCode.popRate.rate;
      }

      return 0;
    };

    $scope.getSelectedCount = () => {
      return $scope.availableLineItems.filter((lineItem) => lineItem.selected).length;
    };

    $scope.selectAll = () => {
      $scope.allSelected = !$scope.allSelected;
      $scope.availableLineItems.forEach((lineItem) => {
        lineItem.selected = $scope.allSelected;
      });
    };

    $scope.toggleLineItem = (lineItem) => {
      lineItem.selected = !lineItem.selected;
      $scope.allSelected = $scope.availableLineItems.length > 0
        && $scope.availableLineItems.every((item) => item.selected);
    };

    $scope.addSelected = () => {
      const selected = $scope.availableLineItems.filter((lineItem) => lineItem.selected);

      if (!selected.length) {
        toastr.warning('Select at least one line item to add.', 'No Selection');
        return;
      }

      $scope.saving = true;

      InvoiceService.addLineItems($scope.invoice.id, selected).then((response) => {
        $uibModalInstance.invoice = response.data;
        $uibModalInstance.success();
      }, (failure) => {
        $scope.saving = false;

        let message = 'Could not add line items to the invoice.';

        if (failure.status === 409) {
          message = (failure.data && failure.data.message)
            ? failure.data.message
            : 'This employee/charge code is already on the invoice.';
        } else if (failure.status === 404) {
          message = 'Invoice not found.';
        } else if (failure.status === 400 && failure.data && failure.data.message) {
          message = failure.data.message;
        }

        toastr.error(message, 'Error');
      });
    };

    $scope.cancel = () => {
      $uibModalInstance.dismiss();
    };
  }
}

export default InvoiceAddLineItemModalController;



// WEBPACK FOOTER //
// ./client/common/modals/InvoiceAddLineItemModal/invoiceAddLineItemModal.controller.js